/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Csv_Import_FormatInputs */

const en_statement_tree_csv_import_format = /** @type {(inputs: Statement_Tree_Csv_Import_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV format`)
};

const nl_statement_tree_csv_import_format = /** @type {(inputs: Statement_Tree_Csv_Import_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV-formaat`)
};

/**
* | output |
* | --- |
* | "CSV format" |
*
* @param {Statement_Tree_Csv_Import_FormatInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_import_format = /** @type {((inputs?: Statement_Tree_Csv_Import_FormatInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_Import_FormatInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_import_format(inputs)
	return en_statement_tree_csv_import_format(inputs)
});